const config = {
  API_URL: 'https://api.autovolt.ai',
  APP_URL: 'https://app.autovolt.ai'
};

export default config;